import { defineStore } from "pinia";
import { inject, reactive } from "vue";
import { AcquaintApiClient } from "../services/AcquaintApiClient";
import { Mutex } from "async-mutex";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { LookupConfiguration } from "../types/configuration/LookupConfiguration";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";

export const useLookupConfigurationStore = defineStore(
  "lookupconfiguration",
  () => {
    const mutex = new Mutex();

    /** Central Cache of all Configuration, Each configuration is grouped by its table */
    const configurationCache = reactive<LookupConfiguration[]>([]);
    const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;

    /** Lookups the configuration Cache for the passed Type (table name) the Additional Fields paramter allows us to pull back more than just the ID and Description for A Configuration */
    const getLookupConfigurationDescription = async (
      lookupSource: LookupTableSource,
      recordId: number,
    ) => {
      const configurationDescription = await mutex.runExclusive(async () => {
        const foundConfigurationDescription =
          findCachedLookupConfigurationDescription(lookupSource, recordId);

        if (foundConfigurationDescription) {
          return foundConfigurationDescription.description;
        }

        const lookupConfigurationItem: IDDescriptionPair =
          await getLookupConfigurationFromApi(lookupSource, recordId);
        configurationCache.push({
          id: lookupConfigurationItem.id,
          description: lookupConfigurationItem.description,
          sourceId: lookupSource,
        });

        return lookupConfigurationItem.description;
      });

      return configurationDescription;
    };

    /** Checks current cache for item */
    const findCachedLookupConfigurationDescription = (
      lookupSource: LookupTableSource,
      id: number,
    ) => {
      return configurationCache.find(
        (cachedItem) =>
          cachedItem.id == id && cachedItem.sourceId == lookupSource,
      );
    };

    /** Retrieves the requested configuration item from the api  */
    const getLookupConfigurationFromApi = async (
      lookupSource: LookupTableSource,
      recordId: number,
    ): Promise<IDDescriptionPair> => {
      return await acquaintApiClient.httpGet<IDDescriptionPair>(
        `app/system/lookup/${lookupSource}/${recordId}`,
      );
    };

    return { getLookupConfigurationDescription };
  },
);
